import { lt } from '@mews/framework';
import { ButtonVariant, TableBulkActionButton } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { AddProductToPropertyDialog } from '../../_shared/AddProductToPropertyDialog';
import { useHandleAssignProperty } from '../../../hooks/useHandleAssignProperty';

interface Props {
    buttonVariant?: ButtonVariant;
    isDisabled?: boolean;
    productId: string;
    propertyIds?: string[];
}

export const BulkAddToProperty = ({ buttonVariant = 'primary', isDisabled, productId, propertyIds }: Props) => {
    const { handleAddToProperty, handleConfirm, handlers, renderConfigureProductDialog, states } =
        useHandleAssignProperty(productId);

    return (
        <>
            <TableBulkActionButton
                variant={buttonVariant}
                icon={IconName.Add}
                disabled={isDisabled}
                onClick={handleAddToProperty}
            >
                {lt('AddToProperty')}
            </TableBulkActionButton>
            {states.isDialogOpened && (
                <AddProductToPropertyDialog
                    onConfirm={handleConfirm}
                    onCancel={handlers.handleCancel}
                    propertyIds={propertyIds}
                />
            )}
            {renderConfigureProductDialog()}
        </>
    );
};
